import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutTablePaymentsDue extends Layout {
	sourcePaymentsDue: DataSource;
	tablePaymentsDue: Table;
}
